/* global axios */

import ApiClient from './ApiClient';

class AgentConversationsAPI extends ApiClient {
  constructor() {
    super('agent_conversations', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  findOrCreate(participantId) {
    return axios.post(this.url, { participant_id: participantId });
  }

  getMessages(conversationId, { beforeId } = {}) {
    return axios.get(`${this.url}/${conversationId}/agent_messages`, {
      params: beforeId ? { before_id: beforeId } : {},
    });
  }

  sendMessage(conversationId, { content, signedIds = [] } = {}) {
    return axios.post(`${this.url}/${conversationId}/agent_messages`, {
      content,
      signed_ids: signedIds,
    });
  }

  markRead(conversationId) {
    return axios.patch(`${this.url}/${conversationId}/agent_messages/read`);
  }
}

export default new AgentConversationsAPI();
